var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.getClassName("parts-item") },
    [
      _c("v-img", {
        class: _vm.getClassName("parts-item__thumbnail"),
        attrs: {
          src: _vm.item.option.color.thumbnail,
          alt: _vm.item.name,
          contain: "",
          width: _vm.media ? "54" : "78",
          height: _vm.media ? "46" : "74"
        }
      }),
      _vm._v(" "),
      _c("div", { class: _vm.getClassName("parts-item__content") }, [
        _c("div", { class: _vm.getClassName("parts-item__name") }, [
          _vm._v(
            _vm._s(_vm.item.name) + "・" + _vm._s(_vm.item.option.color.name)
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.getClassName("parts-item__quantity") },
          [
            _c("v-text-field", {
              class: _vm.getClassName("parts-item__field"),
              attrs: {
                type: "number",
                min: "1",
                outlined: "",
                "hide-details": "",
                dense: ""
              },
              model: {
                value: _vm.internalValue,
                callback: function($$v) {
                  _vm.internalValue = $$v
                },
                expression: "internalValue"
              }
            }),
            _vm._v(" "),
            _c("span", { class: _vm.getClassName("parts-item__unit") }, [
              _vm._v(_vm._s(_vm.item.unit))
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          class: _vm.getClassName("parts-item__remove"),
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.removeParts(_vm.item)
            }
          }
        },
        [_vm._v("削除")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }